function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, shortCode, shortUrlCopied, shortUrlLoading, showBetaBanner) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'hidden': $attr(`hidden`)
        }, {
          'global-action-bar-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.getBetaBannerControls().length || $attr(`beta-banner-parts`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              hidden: !showBetaBanner,
            }, {
              'beta-banner-container': true,
              'global-action-bar-container-item': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'beta-banner-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = ($attr(`beta-banner-parts`));
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, part, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((part.type === $helpers.MessagePartType.Text) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (part.text) + "");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : (part.type === $helpers.MessagePartType.Link) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("a", {
                          "attrs": {
                            href: part.href,
                            target: part.newTab ? `_blank` : `_self`,
                          },
                          "class": {
                            'beta-banner-container-link': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(part.text);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : (part.type === $helpers.MessagePartType.ActionLink) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", {
                          "on": {
                            click: () => $helpers.handleAction(part.actionName, part.value)
                          },
                          "class": {
                            'beta-banner-container-link': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(part.text);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : (part.type === $helpers.MessagePartType.ActionButton) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "attrs": {
                            icon: part.icon,
                            size: 'small',
                            theme: 'tertiary',
                          },
                          "on": {
                            click: () => $helpers.handleAction(part.actionName, part.value),
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (part.text) + "");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var part = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((part.type === $helpers.MessagePartType.Text) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("span", (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (part.text) + "");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : (part.type === $helpers.MessagePartType.Link) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("a", {
                              "attrs": {
                                href: part.href,
                                target: part.newTab ? `_blank` : `_self`,
                              },
                              "class": {
                                'beta-banner-container-link': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(part.text);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : (part.type === $helpers.MessagePartType.ActionLink) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("span", {
                              "on": {
                                click: () => $helpers.handleAction(part.actionName, part.value)
                              },
                              "class": {
                                'beta-banner-container-link': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(part.text);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : (part.type === $helpers.MessagePartType.ActionButton) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-button", {
                              "attrs": {
                                icon: part.icon,
                                size: 'small',
                                theme: 'tertiary',
                              },
                              "on": {
                                click: () => $helpers.handleAction(part.actionName, part.value),
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (part.text) + "");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(($helpers.getBetaBannerControls().length) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'beta-banner-controls': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-control-bar", {
                  "attrs": {
                    controls: JSON.stringify($helpers.getBetaBannerControls())
                  },
                  "on": {
                    select: $helpers.betaBannerControlSelect
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'global-action-bar-container-item': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-short-url-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((shortCode) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": {
                  type: 'text',
                  readonly: true
                },
                "props": {
                  value: $helpers.getShortUrl()
                },
                "hook": {
                  insert: ({
                    elm
                  }) => $helpers.handleShortUrlInputInsert(elm)
                },
                "class": {
                  'mp-short-url-input': true
                },
              }));
              __jade_nodes = __jade_nodes.concat((shortUrlCopied) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                  "attrs": {
                    direction: 'up',
                    'with-caret': true,
                    open: true,
                  },
                  "on": {
                    close: $helpers.clearShortUrlCopied,
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-short-url-copied': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Link copied!");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    icon: 'duplicate',
                    size: 'small',
                    theme: 'tertiary',
                  },
                  "on": {
                    click: $helpers.copyShortUrl,
                  },
                  "class": {
                    'mp-short-url-copy': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Copy");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    icon: 'x',
                    size: 'small',
                    theme: 'tertiary',
                  },
                  "on": {
                    click: $helpers.closeShortUrl,
                  },
                  "class": {
                    'mp-short-url-close': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Close");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : (shortUrlLoading) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    icon: 'link',
                    size: 'small',
                    theme: 'tertiary',
                    'style-override': require('./oval-trigger-btn.styl?inline'),
                  },
                  "on": {
                    click: $helpers.createShortUrl,
                  },
                  "class": {
                    'mp-short-url-create': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": {
                    placement: 'left'
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Generate short link");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "shortCode" in locals ? locals.shortCode : typeof shortCode !== "undefined" ? shortCode : undefined, "shortUrlCopied" in locals ? locals.shortUrlCopied : typeof shortUrlCopied !== "undefined" ? shortUrlCopied : undefined, "shortUrlLoading" in locals ? locals.shortUrlLoading : typeof shortUrlLoading !== "undefined" ? shortUrlLoading : undefined, "showBetaBanner" in locals ? locals.showBetaBanner : typeof showBetaBanner !== "undefined" ? showBetaBanner : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;